import {
	BaseControl, Button, ButtonGroup, RadioControl, Dropdown, ColorPicker 
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import ImageControl from '../image-control'
import { i18n } from 'cartzillagb'

function BackgroundSettings( props ) {
	const {
		backgroundType = '',
		onChangeBackgroundType,
		background,
		onChangeBackground,
		onRemoveBackground,
		backgroundColor,
		onChangeBackgroundColor,
		backgroundImageURL,
		onChangeBackgroundImage,
		onRemoveBackgroundImage,
		softBackground = true,
		prefix = 'bg-',
		backgroundLabel = "Background Color",
		backgroundImageLabel = "Background Image",
		disableAlpha = true,
	} = props

	const customColorPickerLabel = __( 'Custom color picker', i18n )
	
	return (
		<div className="components-base-control cartzillagb-radiobutton-bg"> 
			<Fragment>
				{ applyFilters( 'cartzillagb.background-settings.before', null, props ) }
				{ onChangeBackgroundType  &&
				<BaseControl
					label={ __( 'Background Type', i18n ) }
					id={ "bg-color" }
				>
					<ButtonGroup
						aria-label={ __( 'Image Size', i18n ) }
					>
						{ onChangeBackground &&
						<Button
							isPrimary={ backgroundType === '' }
							isDefault={ backgroundType !== '' }
							onClick={ () => {
								onChangeBackgroundType( '' )
							} }
						>
							{ __( 'Single', i18n ) }
						</Button>
						}
						{ ( onChangeBackgroundImage && onChangeBackground ) &&
						<Button
							isPrimary={ backgroundType === 'image' }
							isDefault={ backgroundType !== 'image' }
							onClick={ () => {
								onChangeBackgroundType( 'image' )
							} }
						>
							{ __( 'Image', i18n ) }
						</Button>
						}
					</ButtonGroup>
				</BaseControl>
				}
				{ ( onChangeBackground && backgroundType === '' ) &&
					<RadioControl
						label={ backgroundLabel }
						selected={ background }
						options={ [
							{ label: __( 'Primary', i18n ), value: `${prefix}primary` },
							{ label: __( 'Accent', i18n ), value: `${prefix}accent` },
							{ label: __( 'Secondary', i18n ), value: `${prefix}secondary` },
							{ label: __( 'Success', i18n ), value: `${prefix}success` },
							{ label: __( 'Danger', i18n ), value: `${prefix}danger` },
							{ label: __( 'Warning', i18n ), value: `${prefix}warning` },
							{ label: __( 'Info', i18n ), value: `${prefix}info` },
							{ label: __( 'Dark', i18n ), value: `${prefix}dark` },
							{ label: __( 'Light', i18n ), value: `${prefix}light` },
							...( softBackground ? [
								{ label: __( 'Faded Primary', i18n ), value: `${prefix}faded-primary` },
								{ label: __( 'Faded Secondary', i18n ), value: `${prefix}faded-secondary` },
								{ label: __( 'Faded Success', i18n ), value: `${prefix}faded-success` },
								{ label: __( 'Faded Danger', i18n ), value: `${prefix}faded-danger` },
								{ label: __( 'Faded Warning', i18n ), value: `${prefix}faded-warning` },
								{ label: __( 'Faded Light', i18n ), value: `${prefix}faded-light` },
								{ label: __( 'Faded Info', i18n ), value: `${prefix}faded-info` },
								{ label: __( 'Faded Dark', i18n ), value: `${prefix}faded-dark` },
							] : [] ),
						] }
						onChange={ onChangeBackground }
					/>
				}
				{ ( ( backgroundType === '' ) && onChangeBackgroundColor ) &&
				<div className="components-color-palette__custom-clear-wrapper clear-button">
					<Dropdown
						className="components-color-palette__custom-color"
						contentClassName="components-color-palette__picker"
						renderToggle={ ( { isOpen, onToggle } ) => (
							<Button
								aria-expanded={ isOpen }
								onClick={ onToggle }
								aria-label={ customColorPickerLabel }
								isLink
							>
								{ __( 'Custom Color', i18n ) }
							</Button>
						) }
						renderContent={ () => (
							<ColorPicker 
								color={ backgroundColor }
								onChangeComplete={ onChangeBackgroundColor }
								disableAlpha={ disableAlpha }
							/>
						) }
					/>
					<Button
						className="components-color-palette__clear"
						type="button"
						onClick={ onRemoveBackground }
						isSmall
						isDefault
					>
						{ __( 'Clear', i18n ) }
					</Button>
				</div>
				}
				{ ( ( onChangeBackgroundImage && backgroundType === 'image' ) || ( onChangeBackgroundImage && onChangeBackground === undefined ) ) &&
					<ImageControl
						label={ backgroundImageLabel }
						onRemove={ media => {
							if ( onChangeBackgroundType ) {
								onChangeBackgroundType( '' )
							}
							onRemoveBackgroundImage( media )
						} }
						onChange={ media => {
							if ( onChangeBackgroundType ) {
								onChangeBackgroundType( media.url.match( /(mp4|webm|ogg)/i ) ? 'video' : '' )
							}
							onChangeBackgroundImage( media )
						} }
						imageURL={ backgroundImageURL }
						allowedTypes={ onChangeBackgroundType ? [ 'image', 'video' ] : [ 'image' ] }
					/>
				}
				{ applyFilters( 'cartzillagb.background-settings.after', null, props ) }
			</Fragment>
		</div>
	)
}

export default BackgroundSettings